import React from 'react';

const ImageContainer = ({ frameImage, screenImage }) => {
  return (
    <div style={styles.container}>
      <div style={styles.shadowYellow}></div>
      <div style={styles.shadowBlue}></div>
      <img src={frameImage} alt="iPhone frame" style={styles.frame} />
      <img src={screenImage} alt="Screen mask" style={styles.screen} />
    </div>
  );
};

export default ImageContainer;

const styles = {
  container: {
    position: 'relative',
    width: 215,
    height: 416,
  },
  shadowYellow: {
    position: 'absolute',
    top: 7,
    left: 7,
    width: 200,
    height: 400,
    backgroundColor: 'rgba(211, 226, 5, 1)',
    borderRadius: '20px',
    zIndex: 1,
  },
  shadowBlue: {
    position: 'absolute',
    top: 14,
    left: 14,
    width: 200,
    height: 400,
    backgroundColor: 'rgba(25, 118, 210, 1)',
    borderRadius: '20px',
    zIndex: 0,
  },
  frame: {
    position: 'absolute',
    width:199,
    height: 400,
    objectFit: 'cover',
    zIndex: 2,
    borderRadius: '20px',
  },
  screen: {
    position: 'absolute',
    top:10,
    left:13,
    width: 173,  
    height: 380, 
    objectFit: 'cover',
    zIndex: 3,
    borderRadius: '15px',
  },
};
